// extracted by mini-css-extract-plugin
module.exports = {"ProseMirror":"SidebarContextMenu_ProseMirror__bZCz6","sidebarContextMenu":"SidebarContextMenu_sidebarContextMenu__2OKVv","rotate-shadow":"SidebarContextMenu_rotate-shadow__18sY8"};